"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PinEntry;
(function (PinEntry) {
    PinEntry[PinEntry["CORRECT"] = 0] = "CORRECT";
    PinEntry[PinEntry["CANCELLED"] = 1] = "CANCELLED";
    PinEntry[PinEntry["INCORRECT"] = 2] = "INCORRECT";
    PinEntry[PinEntry["ERROR"] = 3] = "ERROR";
})(PinEntry = exports.PinEntry || (exports.PinEntry = {}));
